import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { EmpAttendenceRoutingModule } from './emp-attendence-routing.module';
import { ListComponent } from './list/list.component';
import { AddComponent } from './add/add.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxSpinnerModule } from 'ngx-spinner';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { PipeModule } from 'app/shared/pipes/pipe.module';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { AttendenceReportComponent } from './attendence-report/attendence-report.component';
import { MatMenuModule } from '@angular/material/menu';


@NgModule({
  declarations: [
    ListComponent,
    AddComponent,
    AttendenceReportComponent
  ],
  imports: [
    CommonModule,
    EmpAttendenceRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    NgSelectModule,
    NgxSpinnerModule,
    NgbModule,
    NgxDatatableModule,
    PipeModule,
    MatSlideToggleModule,
    MatMenuModule,
  ]
})
export class EmpAttendenceModule { }
